import React from "react"

import FacebookLink from "./facebookLink.js"
import TwitterLink from "./twitterLink.js"
import LinkedInLink from "./linkedInLink.js"
import InstagramLink from "./instagramLink.js"

const SocialLinks = ({ variant, share }) => (
  <>
    <FacebookLink
      variant={variant}
      share={share}
    />
    <TwitterLink
      variant={variant}
      share={share}
    />
    {!share && <InstagramLink variant={variant} />}
    {!share &&
      <LinkedInLink
        variant={variant}
        share={share}
      />
    }
  </>
)

SocialLinks.defaultProps = {
  variant: 'Light',
  share: false,
}

export default SocialLinks
